import Backbone from 'backbone'
import DashboardAIAssistant from 'scoreboard/dashboards/edit/dashboard-ai-assistant'

const DashboardAIAssistantTestView = Backbone.View.extend({

	render: function() {
		let aiAssistantView = new DashboardAIAssistant()
		this.$el.empty().html(aiAssistantView.el)
		aiAssistantView.render()
		this.$el.css({
			'height': '100%',
			'overflow': 'auto'
		})
		return this
	},

	autoRemove: true

})

export default DashboardAIAssistantTestView
